import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import BackButton from "../components/utils/BackButton";

const articles = [
  {
    title: "Guide to Writing a Marriage Biodata",
    image: "guidelines/Marriage.jfif",
    slug: "guidelines-for-marriage-biodata",
    category: "biodata",
  },
  {
    title: "Biodata Format for Groom",
    image: "articles/groom.jpg",
    slug: "biodata-format-for-groom",
    category: "biodata",
  },
  {
    title: "Biodata Format for Bride",
    image: "/articles/bride.jpg",
    slug: "biodata-format-for-bride",
    category: "biodata",
  },
  {
    title: "Marriage Certificate",
    image: "/articles/marriage-certificate.jpg",
    slug: "marriage-certificate",
    category: "legal",
  },
  {
    title: "Importance of Gold in Indian Marriages",
    image: "/articles/gold.webp",
    slug: "importance-of-gold-in-indian-wedding",
    category: "culture",
  },
  {
    title: "Valentine's Day",
    image: "/articles/valentine.jpg",
    slug: "valentine's-day",
    category: "culture",
  },
  {
    title: "Arranged vs Love Marriage in India",
    image: "/articles/arranged2.webp",
    slug: "arranged-vs-love-marriage-india",
    category: "marriage",
  },
  {
    title: "Marathi Marriage Biodata Format",
    slug: "marathi-marriage-biodata-format",
    category: "biodata",
    image: "/articles/MarathiWed.jpg",
  },
  {
    title: "Hindi Marriage Biodata Format",
    slug: "hindi-marriage-biodata-format",
    category: "biodata",
    image: "/articles/Hinduwed.jpg",
  },
  {
    title: "Checklist Before Finalizing Marriage",
    slug: "checklist-before-finalizing-marriage",
    category: "marriage",
    image: "/articles/Checklist.jpg",
  },
  {
    title: "Name Change After Marriage",
    slug: "name-change-after-marriage",
    category: "legal",
    image: "/articles/NameChange.avif",
  },
    {
    title: "Modern Marriage Biodata Format 2026",
    slug: "modern-marriage-biodata-format-2026",
    category: "biodata",
    image: "/articles/modernBiodata.png",
  },
  {
    title: "Whatsapp Marriage Biodata: A Quick Guide",
    slug: "whatsapp-marriage-biodata-format",
    category: "biodata",
    image: "/articles/whatsappbiodata.jpg",
  },
  {
    title: "Best Hobbies for Marriage Biodata",
    slug: "best-hobbies-for-marriage-biodata",
    category: "biodata",
    image: "/articles/hobbies.jpg",
  },
  {
    title:"Marriage Biodata for Software Engineers",
    slug: "marriage-biodata-for-software-engineers",
    category: "biodata",
    image: "/articles/SoftwareBiodata.webp",
  }
];

export default function ArticlesPage() {
  const grouped = {
    biodata: articles.filter((a) => a.category === "biodata"),
    marriage: articles.filter((a) => a.category === "marriage"),
    legal: articles.filter((a) => a.category === "legal"),
    culture: articles.filter((a) => a.category === "culture"),
  };

  const renderSection = (title, items, description) => (
    <Box sx={{ mb: 6 }}>
      <Typography variant="h5" fontWeight={700} mb={1}>
        {title}
      </Typography>

      <Typography sx={{ mb: 3, color: "#555" }}>
        {description}
      </Typography>

      <Grid container spacing={3}>
        {items.map((article) => (
          <Grid key={article.slug} item xs={12} sm={6} md={4}>
            <Link
              to={`/articles/${article.slug}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Card
                sx={{
                  cursor: "pointer",
                  borderRadius: 3,
                  overflow: "hidden",
                  transition: "0.25s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 12px 26px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={article.image}
                  alt={article.title}
                  sx={{ width: "100%", height: 180, objectFit: "cover" }}
                />
                <CardContent>
                  <Typography fontWeight={600}>
                    {article.title}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  return (
    <Box sx={{ py: 6, background: "#FAFAFA" }}>
      <Helmet>
        <title>Marriage Articles & Guides</title>
        <meta
          name="description"
          content="Explore marriage biodata guides, legal documents, and Indian wedding traditions."
        />
        <link rel="canonical" href="https://www.marriagebiodata.live/articles" />
      </Helmet>

      <Container maxWidth="lg">
        <BackButton fallback="/" />
        <Typography variant="h4" fontWeight={700} mb={2}>
          Articles & Guides
        </Typography>

        <Typography sx={{ mb: 4, color: "#444" }}>
          Explore detailed guides on marriage biodata creation, legal
          documentation, and Indian wedding traditions.
        </Typography>

        {renderSection(
          "Biodata Guides",
          grouped.biodata,
          "Learn how to create professional marriage biodata for bride and groom."
        )}

        {renderSection(
          "Marriage Types & Trends",
          grouped.marriage,
          "Understand arranged and love marriages in India."
        )}

        {renderSection(
          "Legal & Documentation",
          grouped.legal,
          "Important legal guides like marriage certificate process."
        )}

        {renderSection(
          "Culture & Traditions",
          grouped.culture,
          "Explore Indian wedding traditions and cultural practices."
        )}
      </Container>
    </Box>
  );
}